// extracted by mini-css-extract-plugin
var _1 = "no_plans_result--hUXc9cvC";
var _2 = "no_plans_text--nzsS7IgU";
var _3 = "plans_table--xOQwUZ2c";
export { _1 as "no_plans_result", _2 as "no_plans_text", _3 as "plans_table" }
